/* eslint-disable no-mixed-operators */
import * as React from 'react';
import { connect } from 'react-redux';
import { changeMode } from '../actions';
import { getReportDispatch, getDocumentTypesDispatch } from '../thunks';
import _ from 'lodash';
import { ReportStatus } from '../types';
import AccessMediator from '../components/AccessMediator';
import Order from '../components/Order';
import NonRnDUser from '../components/NonRnDUser';
import RbLoadingSpinner from '../../../bosch-react/components/loading-spinner/RbLoadingSpinner';
import NotFound from '../components/NotFound';
import { IUserProfile } from '../../Auth/types';
import { RootState } from '../../../store/store';
import { withRouter } from 'react-router-dom';
import { showDialog } from '../../Dialog/actions';
import Helper from '../../../core/libraries/Helper';
import { findReportId } from '../services';

interface IAccessLoaderProps {
    userProfile: IUserProfile | undefined,
    report: any,
    changeMode: typeof changeMode,
    getReportDispatch: any,
    getDocumentTypesDispatch: any,
    match: any,
    history: any,
    status: any,
    showDialog: any,
    isLoading: boolean,
    mode: string,
};
interface IAccessLoaderState {
    id: number,
}
class AccessLoader extends React.Component<IAccessLoaderProps, IAccessLoaderState> {

    constructor(props: IAccessLoaderProps) {
        super(props);
        this.state = {
            id: 0,
        }
    }

    async componentDidMount() {
        const parameters: any = this.props.match.params;

        const id = parameters["id"] as string;
        if (Helper.isValidGuid(id.replaceAll("_", "-"))) {
            const reportId = await findReportId(id)
            !!reportId && Helper.openAMPage(reportId, false)
        }
        else {
            this.setState(
                {
                    id: parseInt(id)
                }
            )
            this.props.getReportDispatch(id, (result: any) => {
                if (!_.isNil(result)) {
                    this.props.getDocumentTypesDispatch(result.uploadType);
                }
            });
        }
    }

    loadingScreen = <div className="ms-Grid">
        <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12" style={{ textAlign: "center", paddingTop: "35vh" }}>
                <RbLoadingSpinner size="1.5" />
            </div>
        </div>
    </div>

    render() {
        let element = null;
        switch (this.props.status) {
            case ReportStatus.DECLINED:
            case ReportStatus.PENDING:
            case ReportStatus.PUBLISHED: {
                element = <AccessMediator match={this.props.match} />
                break;
            }
            case ReportStatus.NO_PERMISSION: {
                element = <Order history={this.props.history} reportId={this.state.id} />
                break;
            }
            case ReportStatus.NON_RND: {
                element = <NonRnDUser />;
                break;
            }
            case ReportStatus.NOT_FOUND:
                element = <NotFound id={this.state.id} />
                break;
            default: // Deleted 
                element = <NotFound id={this.state.id} />
                break;
        }
        return (
            !this.props.isLoading && !!this.props.userProfile &&
            <div className="ms-Grid">
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm1" />
                    <div className="ms-Grid-col ms-sm10">
                        {element}
                    </div>
                    <div className="ms-Grid-col ms-sm1" />
                </div>
            </div>
            || this.loadingScreen
        )
    }

}

const mapStateToProps = (state: RootState) => ({
    userProfile: state.auth.userProfile,
    report: state.accessMediator.report,
    isLoading: state.accessMediator.isLoading,
    status: state.accessMediator.status,
    mode: state.accessMediator.mode
});

export default withRouter(connect(mapStateToProps, {
    changeMode,
    getReportDispatch,
    getDocumentTypesDispatch,
    showDialog,
})(AccessLoader));